module.exports = __webpack_public_path__ + "img/banner_CustomMade.e21add4e.jpg";